<div *ngFor="let value of elementsValues">
	<span  class="badge-light badge-pill margin-right">{{value | translate}}</span>
</div>
